import { render } from "./HeaderLink.vue?vue&type=template&id=54aaa4ef"
import script from "./HeaderLink.vue?vue&type=script&lang=js"
export * from "./HeaderLink.vue?vue&type=script&lang=js"

import "./HeaderLink.vue?vue&type=style&index=0&id=54aaa4ef&lang=css"
script.render = render

export default script